import { Check } from "baseui/icon";
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { useSnackbar } from "baseui/snackbar";
import { useEffect, useState } from 'react';
import { Notification } from "baseui/notification";
import { DeleteRelationsCommand, RELATION_TYPE, useDeleteRelationMutation, useGetObjectByIdQuery } from "../../../services/objects";
import { FormattedMessage, useIntl } from 'react-intl';

interface IDeleteRelationDialogProps {
    fromObjectId: string,
    toObjectId: string,
    resourceGroupId: string,
    relationType: keyof typeof RELATION_TYPE,
    isOpen: boolean,
    setIsOpen: any,
}
const DeleteRelationDialog = ({ fromObjectId, toObjectId, resourceGroupId, relationType, isOpen, setIsOpen }: IDeleteRelationDialogProps) => {
    const { enqueue } = useSnackbar();
    const intl = useIntl();
    const [deleteObject, deleteObjectResult] = useDeleteRelationMutation();
    const { data: objData, isLoading: objLoading, isSuccess: objIsSucess } = useGetObjectByIdQuery({ id: toObjectId, resourceGroupId: resourceGroupId }, { skip: !toObjectId });

    function onDeleteObjectClick(): void {
        const cmd: DeleteRelationsCommand = {
            fromObjectId: fromObjectId,
            toObjectId: toObjectId,
            type: relationType,
            resourceGroupId: resourceGroupId
        }
        deleteObject(cmd);
    }

    useEffect(() => {
        if (deleteObjectResult?.isSuccess) {
            enqueue({
                message: intl.formatMessage({ id: "Relations.DeleteSuccessful", defaultMessage: 'Sucessfully deleted' }),
                startEnhancer: ({ size }) => <Check size={size} />,
            });
            setIsOpen(false);
        }
    }, [deleteObjectResult]);

    return (
        <>
            <Modal closeable onClose={() => setIsOpen(false)} isOpen={isOpen}>
                <ModalHeader>
                    <FormattedMessage id="Relations.DeleteRelation" defaultMessage="Delete Relation" />
                </ModalHeader>
                <ModalBody>
                    <FormattedMessage id="Relations.DeleteRelationQuestion" defaultMessage="Do you really want to delete Relation {relationType} to {object}?"
                        values={{
                            relationType: <b>{intl.formatMessage({ id: "Relations." + relationType, defaultMessage: relationType })}</b>,
                            object: <b>{objData?.description || objData?.name}</b>
                        }} />
                </ModalBody>
                <ModalFooter>
                    <ModalButton kind="tertiary" onClick={() => setIsOpen(false)}>
                        <FormattedMessage id="cancel" defaultMessage="Cancel" />
                    </ModalButton>
                    <ModalButton onClick={onDeleteObjectClick} isLoading={deleteObjectResult.isLoading}><FormattedMessage id="ok" defaultMessage="Ok" /></ModalButton>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default DeleteRelationDialog